import { createGlobalStyle } from "styled-components";

export const StyleStyledUIGlobal = createGlobalStyle`
 * {
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.pantone2726C} ${({ theme }) => theme.pantone656C};
  }

  *::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  *::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.pantone656C};
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.pantone2726C};
    border-radius: 0px;
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.pantone2726C};
    filter: brightness(1.1)
  }
  
  *::-webkit-scrollbar-track:hover {
    filter: brightness(1.1)
  }

  *::-webkit-scrollbar-track:active {
    filter: brightness(1.1)
  }
  .menu-item-selected{
	  border-right: 3px solid ${({ theme }) => theme.pantone2726C};
  }
`;
